import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { css } from 'styled-components';
import Colors from '../../constants/Colors';
import { FontWeight } from 'components/Text';


import {
    Dialog,
    DialogBody,
    DialogIcon,
    DialogText
} from './styles';

export const DialogConfirm = styled.button`
width: calc(50% - 10px);
margin-left: 10px;
height: 40px;
background: ${Colors.PINK};
border: 0px;
border-radius: 5px;
font-weight: 600;
text-transform: uppercase;
color: #fff;
cursor: pointer; 
`;

export const TextArea2 = styled.textarea`
width:100%;
height: 120px;
padding:15px;
border:2px solid ${Colors.GRAY[3]};
border-radius:8px;
resize:none;
font-family: Courier, monospace;
font-weight: ${FontWeight.SemiBold};
color: ${Colors.GRAY[6]};
font-size:14px;
`;

export const DialogRejected = styled.button`
width: calc(50% - 10px);
margin-right: 10px;
height: 40px;
background: ${Colors.PURPLE};
border: 0px;
border-radius: 5px;
font-weight: 600;
text-transform: uppercase;
color: #fff;
cursor: pointer;     
`;

export const ContentTextArea = styled.div`
width: 100%;  
margin-top: 0px;
margin-bottom: 0px;
p{
  color: ${Colors.GRAY[0]};
  margin-bottom: 5px;
  margin-top: 10px;
  font-weight: 800;
  font-size: 14px;
}
`;

export default function DialogComponent(props) {
    const [visible, setVisible] = useState(props.show);
    const myRef = useRef();

    const handleClickOutside = e => {
        // if (!myRef.current.contains(e.target)) {
        props.setDialog && props.setDialog({ visible: false, title: null, icon: null, args: null })
        // }
    };

    useEffect(() => {
        if (!props.onButtonClose) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    });

    useEffect(() => {
        setVisible(props.show);
    }, [props.show]);


    return (
        <Dialog canShow={props.show} forceOnTop={props.forceOnTop}>
            <DialogBody ref={myRef} width={props.width} bodyPadding={props.bodyPadding}>
                {(props.icon || props.title) && (
                    <DialogIcon pink={props.icon}>
                        {props.icon && <FontAwesomeIcon icon={['fas', props.icon]}></FontAwesomeIcon>}
                        <DialogText>{props.title}</DialogText>
                    </DialogIcon>
                )}
                {props.children}
            </DialogBody>
        </Dialog>

    );
}